import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getCookieToken } from "../utils";

interface ThemeState {
  theme: "light" | "dark"; // Restrict to two valid theme values
  minimize: boolean; // Represents whether the UI is minimized
}

const initialState: ThemeState = {
  theme: getCookieToken("theme") || "light", // Default to "light" if no cookie is found
  minimize: false, // Default minimize state is false (not minimized)
};

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    toggleTheme: (state: ThemeState) => {
      state.theme = state.theme === "light" ? "dark" : "light";
    },
    setTheme: (state: ThemeState, action: PayloadAction<"light" | "dark">) => {
      state.theme = action.payload;
    },
    toggleMinimize: (state: ThemeState) => {
      state.minimize = !state.minimize;
    },
    setMinimize: (state: ThemeState, action: PayloadAction<boolean>) => {
      state.minimize = action.payload;
    },
  },
});

export const { toggleTheme, setTheme, toggleMinimize, setMinimize } =
  themeSlice.actions;
export default themeSlice.reducer;
